module.exports = __webpack_public_path__ + "assets/videos/green-xmas-video-intro.mp4?v=0de6ddf2";